/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `LOW` - Low
 * * `MEDIUM` - Medium
 * * `HIGH` - High
 * * `CRITICAL` - Critical
 * @export
 */
export const RiskSeverityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type RiskSeverityEnum = typeof RiskSeverityEnum[keyof typeof RiskSeverityEnum];


export function instanceOfRiskSeverityEnum(value: any): boolean {
    for (const key in RiskSeverityEnum) {
        if (Object.prototype.hasOwnProperty.call(RiskSeverityEnum, key)) {
            if (RiskSeverityEnum[key as keyof typeof RiskSeverityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RiskSeverityEnumFromJSON(json: any): RiskSeverityEnum {
    return RiskSeverityEnumFromJSONTyped(json, false);
}

export function RiskSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskSeverityEnum {
    return json as RiskSeverityEnum;
}

export function RiskSeverityEnumToJSON(value?: RiskSeverityEnum | null): any {
    return value as any;
}

export function RiskSeverityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): RiskSeverityEnum {
    return value as RiskSeverityEnum;
}

